import React from 'react';
import './css/App.css';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import Topbar from './components/Topbar';
import ImageShow from './components/ImageShow';

import Frontpage from './pages/Frontpage';
import Faith from './pages/Faith';
import TKrT from './pages/TKrT';

import Footer from './components/Footer';

// const { SubMenu } = Menu;
// const { Header, Content, Sider } = Layout;

interface Props {

}

interface State {
  loaded: boolean;
}


export default class App extends React.Component<Props, State> {
  constructor(props :Props) {
    super(props);
    this.state = {
        loaded: false,
    };
  }

  render() {
    if (!this.state.loaded) {
      this.setState({ loaded: true });
    }
    return (
      <BrowserRouter>

        <div className="App">
          
          <Switch>

            <Route path="/" exact>
              <Topbar highlighted={0}
                languageI={0}/>
              <ImageShow shown={0}/>
              <Frontpage languageI={0}/>
            </Route>

            <Route path="/tkrt">
              <Topbar highlighted={1}
                languageI={0}/>
              <ImageShow shown={1}/>
              <TKrT languageI={0}/>
            </Route>

            <Route path="/uskosta">
              <Topbar highlighted={2}
                languageI={0}/>
              <ImageShow shown={2}/>
              <Faith languageI={0}/>
            </Route>

            <Route path="/en" exact>
              <Topbar highlighted={0}
                languageI={1}/>
              <ImageShow shown={0}/>
              <Frontpage languageI={1}/>
            </Route>

            <Route path="/en/tkrt">
              <Topbar highlighted={1}
                languageI={1}/>
              <ImageShow shown={1}/>
              <TKrT languageI={1}/>
            </Route>

            <Route path="/en/faith">
              <Topbar highlighted={2}
                languageI={1}/>
              <ImageShow shown={2}/>
              <Faith languageI={1}/>
            </Route>

            <Redirect from="/*" to="/" />
            
          </Switch>

          <Footer />

        </div>

      </BrowserRouter> 
    );
  }
}


/*
  PageFrontpage = () => <Frontpage languageI={this.state.languageI}/>;
  PageAlways = () => <Always languageI={this.state.languageI}/>;
  PageTKrT = () => <TKrT languageI={this.state.languageI}/>;
  PageFaces = () => <Faces languageI={this.state.languageI}/>;

          <Switch>
            <Route path="/" exact component={this.PageFrontpage} />
            <Route path="/aina" component={this.PageAlways} />
            <Route path="/tkrt" component={this.PageTKrT} />
            <Route path="/naamat" component={this.PageFaces} />
          </Switch>
*/

// 15ccfe sininen
// eeeeee harmaa
